//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  type: 'component',
  externalClasses: ['custom-class'],
  props: {
    type: {
      type: String,
      default: "page"
    },
    text: {
      type: String,
      default: "加载中..."
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/app/loading-view/index.vue